













import Vue from 'vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import {
  DeliveryTimeCandidate,
  Query,
  Scalars,
} from '@/types/generated/graphql'
import deliveryTimeCandidatesQuery from '@/graphql/order/deliveryTimeCandidates.gql'

type Data = {
  deliveryTimeCandidates: DeliveryTimeCandidate[]
}

type Methods = {
  onChange: (v: DeliveryTimePickerProps['value']) => void
}

export type DeliveryTimePickerProps = {
  value?: number
  zipCode: string
  shippingDate: Scalars['Date']
  deliveryDate?: Scalars['Date']
}

type Computed = {
  candidate: DeliveryTimeCandidate | undefined
  deliveryTimeSlotOptions: OptionEntry<number>[]
}

export default Vue.extend<Data, Methods, Computed, DeliveryTimePickerProps>({
  inheritAttrs: false,
  name: 'DeliveryTimePicker',
  components: { XDropdown },
  props: {
    value: {
      type: Number,
    },
    shippingDate: {
      type: String,
    },
    zipCode: {
      type: String,
    },
    deliveryDate: {
      type: String,
    },
  },
  data() {
    return {
      deliveryTimeCandidates: [],
    }
  },
  methods: {
    onChange(v: DeliveryTimePickerProps['value']) {
      this.$emit('input', v)
    },
  },
  computed: {
    candidate() {
      return this.deliveryTimeCandidates.find(
        (deliveryTime) => deliveryTime.date === this.deliveryDate
      )
    },
    deliveryTimeSlotOptions() {
      if (!this.candidate) {
        return []
      }

      return this.candidate.deliveryTimeSlots.reduce((options, timeSlot) => {
        return [...options, { value: timeSlot.code, label: timeSlot.label }]
      }, Array<OptionEntry<number>>())
    },
  },
  apollo: {
    deliveryTimeCandidates: {
      query: deliveryTimeCandidatesQuery,
      variables() {
        return {
          input: {
            zipCode: this.zipCode,
            shippingDate: this.shippingDate,
          },
        }
      },
      skip() {
        if (!this.zipCode?.match(/^\d{3}-\d{4}$/) || !this.shippingDate) {
          this.deliveryTimeCandidates = []
          return true
        }
        return false
      },
      update({ deliveryTimeCandidate }: Query) {
        this.$emit('load:done', deliveryTimeCandidate)
        return deliveryTimeCandidate
      },
    },
  },
  watch: {
    deliveryDate: {
      immediate: false,
      handler(value: Scalars['Date']) {
        if (!value) {
          // お届け日が未選択に変更された
          return this.onChange(undefined)
        }

        const existsSelected = this.candidate?.deliveryTimeSlots.some(
          (timeSlot) => timeSlot.code === this.value
        )

        if (!existsSelected) {
          this.onChange(this.candidate?.deliveryTimeSlots?.[0].code)
        }
      },
    },
  },
})
